import {FacetStats} from "./facet-filter/facet-filter.component";
import {FacetFilter, FacetResult, FacetValueResult} from "@flowmaps/flowmaps-typescriptmodels";
import {map, Observable} from "rxjs";
import lodash from "lodash";

export class FacetUtils {

  static isBooleanFacet(facet: FacetStats): boolean {
    return facet.values.every(v => ["false", "true"].includes(v.value))
  }

  static hasActiveFilters = (filters: FacetFilter[]): boolean => !!filters?.length;

  static getFacetValues(query: any, executeFacetsQuery: (query: any) => Observable<FacetResult>, facetName: string): Observable<FacetValueResult[]> {
    if (query.facetFilters?.length) {
      query.facetFilters = (query.facetFilters as FacetFilter[]).filter(f => f.facetName !== facetName);
    }
    return executeFacetsQuery(query).pipe(map(facets => lodash.isEmpty(facets?.facets) ? null : facets.facets[facetName]));
  }
}

export interface GetFacetValues {
  facetName: string;
  allFacets: FacetStats[];
}